document.querySelectorAll('[slider-d5]').forEach(slider => {
  const arrowsEnabled = slider.getAttribute('slider-arrows') === 'true';
  const paginationEnabled = slider.getAttribute('slider-pagination') === 'true';
  const countEnabled = slider.getAttribute('slider-count') === 'true';

  const tracks = Array.from(slider.querySelectorAll('[slider-track-d5]'));
  if (tracks.length === 0) return;

  // Use first track's slides as the source of truth for count/pagination
  const primaryTrack = tracks[0];
  const primarySlides = Array.from(primaryTrack.querySelectorAll('[slider-slide-d5]'));
  if (primarySlides.length === 0) return;

  const total = primarySlides.length;

  // All tracks and their slides
  const trackData = tracks.map(track => ({
    track,
    slides: Array.from(track.querySelectorAll('[slider-slide-d5]'))
  }));

  const countEl = slider.querySelector('[slider-count-d5]');
  const paginationEl = slider.querySelector('[slider-pagination-d5]');
  const nextBtn = slider.querySelector('[slider-next-d5]');
  const prevBtn = slider.querySelector('[slider-prev-d5]');

  if (!arrowsEnabled) {
    if (nextBtn) nextBtn.style.display = 'none';
    if (prevBtn) prevBtn.style.display = 'none';
  }
  if (!paginationEnabled && paginationEl) paginationEl.style.display = 'none';
  if (!countEnabled && countEl) countEl.style.display = 'none';

  let currentIndex = 0;
  let isSyncing = false; // prevent scroll feedback loops

  function getTrackPadding(track) {
    return parseFloat(getComputedStyle(track).paddingLeft) || 0;
  }

  function getTargetScroll(track, slides, index) {
    if (!slides[index]) return 0;
    return (slides[index].offsetLeft - track.offsetLeft) - getTrackPadding(track);
  }

  function buildPagination() {
    if (!paginationEnabled || !paginationEl) return;
    paginationEl.innerHTML = '';
    primarySlides.forEach((_, i) => {
      const dot = document.createElement('div');
      dot.setAttribute('slide-dot-d5', '');
      if (i === currentIndex) dot.setAttribute('active', '');
      dot.addEventListener('click', () => goTo(i));
      paginationEl.appendChild(dot);
    });
  }

  function updateUI() {
    if (paginationEnabled && paginationEl) {
      paginationEl.querySelectorAll('[slide-dot-d5]').forEach((dot, i) => {
        i === currentIndex ? dot.setAttribute('active', '') : dot.removeAttribute('active');
      });
    }
    if (countEnabled && countEl) countEl.textContent = `${currentIndex + 1} / ${total}`;

    // Arrow disabled state based on primary track
    if (arrowsEnabled) {
      const pt = primaryTrack;
      const canScroll = pt.scrollWidth > pt.clientWidth + 1;
      const atStart = currentIndex === 0;
      const atEnd = currentIndex >= total - 1;

      if (prevBtn) atStart ? prevBtn.setAttribute('disabled', '') : prevBtn.removeAttribute('disabled');
      if (nextBtn) atEnd ? nextBtn.setAttribute('disabled', '') : nextBtn.removeAttribute('disabled');
    }

    // center class per track
    trackData.forEach(({ track }) => {
      const canScroll = track.scrollWidth > track.clientWidth + 1;
      track.classList.toggle('center', !canScroll);
    });
  }

  function goTo(index, sourceTrack = null) {
    const targetIndex = Math.max(0, Math.min(index, total - 1));
    currentIndex = targetIndex;
    isSyncing = true;

    trackData.forEach(({ track, slides }) => {
      if (track === sourceTrack) return; // already scrolled by user
      track.scrollTo({ left: getTargetScroll(track, slides, targetIndex), behavior: 'smooth' });
    });

    updateUI();
    setTimeout(() => {
      isSyncing = false;
      updateUI();
    }, 450);
  }

  // Sync on scroll: whichever track the user drags, others follow
  trackData.forEach(({ track, slides }) => {
    track.addEventListener('scrollend', () => {
      if (isSyncing) return;
      const padding = getTrackPadding(track);
      let closest = 0;
      let minDist = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs((slide.offsetLeft - track.offsetLeft) - padding - track.scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      if (closest !== currentIndex) {
        goTo(closest, track);
      } else {
        updateUI();
      }
    });
  });

  if (arrowsEnabled) {
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  }

  window.addEventListener('resize', () => {
    trackData.forEach(({ track, slides }) => {
      track.scrollLeft = getTargetScroll(track, slides, currentIndex);
    });
    updateUI();
  });

  buildPagination();
  updateUI();
});

(function () {
  function initSlider(el) {
    const track = el.querySelector('[data-pcs-track]');
    const dots  = el.querySelectorAll('[data-pcs-dot]');
    const prev  = el.querySelector('[data-pcs-prev]');
    const next  = el.querySelector('[data-pcs-next]');
    if (!track) return;

    const total = track.children.length;
    let current = 0;

    function goTo(index) {
      index = Math.max(0, Math.min(total - 1, index));
      current = index;
      track.scrollTo({ left: track.offsetWidth * index, behavior: 'smooth' });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === total - 1;
    }

    if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); goTo(current - 1); });
    if (next) next.addEventListener('click', (e) => { e.preventDefault(); goTo(current + 1); });

    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => { e.preventDefault(); goTo(+dot.dataset.pcsDot); });
    });

    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const idx = Math.round(track.scrollLeft / track.offsetWidth);
        if (idx !== current) goTo(idx);
      }, 80);
    }, { passive: true });

    goTo(0);
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        initSlider(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px' });

  document.querySelectorAll('[data-pcs]').forEach((el) => observer.observe(el));
})();